import React, { PureComponent } from "react";
import ReactPlayer from "react-player";
import styled from "styled-components";
//
import RichText from "./../rich-text";
//
class VimeoEmbed extends PureComponent {
  state = {
    playing: false
  };

  startPlay = event => {
    event.preventDefault();
    this.setState({ playing: true });
  };

  render() {
    const { caption, vimeo_id } = this.props;
    const { playing } = this.state;
    const imageUrl = `https://i.vimeocdn.com/video/${vimeo_id}_1920x1080.jpg?r=pad`;
    const src = `https://vimeo.com/${vimeo_id}`;

    return (
      <Wrap>
        <PlayerWrap imageUrl={imageUrl}>
          {!playing && (
            <Play onClick={this.startPlay}>
              <PlayIcon />
            </Play>
          )}

          {playing && (
            <ReactPlayer
              playing={true}
              className="react-player"
              height={"auto"}
              width={"100%"}
              url={src}
            />
          )}
        </PlayerWrap>
        {caption && <RichText {...caption} />}
      </Wrap>
    );
  }
}

export default VimeoEmbed;
//

const Wrap = styled.div`
  margin: 0;
  width: 100%;
`;

const PlayerWrap = styled.div`
  background-image: ${props => `url(${props.imageUrl})`};
  background-position: center;
  background-size: cover;
  height: 0;
  padding-top: 56.25%;
  position: relative;
  width: 100%;

  .react-player {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

const Play = styled.button`
  align-items: center;
  background: none;
  border: 0;
  border-radious: 0;
  box-shadow: 0;
  bottom: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  left: 0;
  outline: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

const PlayIcon = styled.div`
  background: transparent;
  border: 0;
  border-color: transparent transparent transparent #fff;
  border-style: solid;
  box-sizing: border-box;
  border-width: 19px 0 19px 30px;
  cursor: pointer;
  height: 37px;
  width: 0;
`;
